import { NgModule } from "@angular/core";
import { CoreCommonModule } from "@core/common.module";
import { ConfirmDialogComponent } from "./confirm-dialog.component";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";

@NgModule({
  declarations: [ConfirmDialogComponent],
  imports: [CoreCommonModule, SweetAlert2Module, SweetAlert2Module.forRoot()],
  exports: [ConfirmDialogComponent],
})
export class ConfirmDialogModule {}
